
export default function TournamentsSection() {
  const tournaments = [
    {
      name: 'NextZen Spring Classic',
      date: 'March 15-17, 2025',
      location: 'Folsom Sports Complex',
      description: 'Annual tournament featuring teams from across Northern California',
      ageGroups: ['U8', 'U10', 'U12', 'U14', 'U16'],
      status: 'Coming Soon'
    },
    {
      name: 'Summer Showcase',
      date: 'July 20-22, 2025',
      location: 'Multiple Venues',
      description: 'Competitive showcase tournament with college scouts in attendance',
      ageGroups: ['U14', 'U16', 'U18'],
      status: 'Coming Soon'
    },
    {
      name: 'Fall Festival Cup',
      date: 'October 12-14, 2025',
      location: 'Folsom Sports Complex',
      description: 'End-of-season celebration tournament for all skill levels',
      ageGroups: ['U6', 'U8', 'U10', 'U12', 'U14'],
      status: 'Save the Date'
    }
  ];

  return (
    <section className="py-16 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Tournaments & Events
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Competitive opportunities to showcase skills and build team spirit
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {tournaments.map((tournament, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <div className="mb-4">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{tournament.name}</h3>
                <div className="flex items-center text-gray-600 mb-1">
                  <i className="ri-calendar-line mr-2"></i>
                  <span>{tournament.date}</span>
                </div>
                <div className="flex items-center text-gray-600 mb-3">
                  <i className="ri-map-pin-line mr-2"></i>
                  <span>{tournament.location}</span>
                </div>
                <div className={`inline-block px-3 py-1 rounded-full text-sm font-semibold ${
                  tournament.status === 'Coming Soon' 
                    ? 'bg-green-100 text-green-800'
                    : tournament.status === 'Coming Soon'
                    ? 'bg-yellow-100 text-yellow-800'
                    : 'bg-blue-100 text-blue-800'
                }`}>
                  {tournament.status}
                </div>
              </div>
              
              <p className="text-gray-600 mb-4">{tournament.description}</p>
              
              <div className="mb-6">
                <h4 className="font-semibold text-gray-900 mb-2">Age Groups:</h4>
                <div className="flex flex-wrap gap-2">
                  {tournament.ageGroups.map((age, idx) => (
                    <span key={idx} className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-sm font-medium">
                      {age}
                    </span>
                  ))}
                </div>
              </div>
              
              <button className="w-full bg-purple-600 text-white py-2 px-4 rounded-lg font-semibold hover:bg-purple-700 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                {tournament.status === 'Coming Soon' ? 'Register Team' : 'Learn More'}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
